import { handleActions } from 'redux-actions';

const initialState = {
  coins: [],
};

export default handleActions({}, initialState);
